import {NgModule} from "@angular/core";
import {SelectpickerDirective} from './selectpicker.directive';

@NgModule({
    declarations: [SelectpickerDirective],
    exports     : [SelectpickerDirective]
})

export class SelectpickerModule {}


// WEBPACK FOOTER //
// ./src/app/directives/selectpicker/selectpicker.module.ts